<!-- 闸坝详情 -->
<template>
  <div class="dialog-dam">
    <div class="header">
      <div class="title">{{ data.xmmc || '-' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <div class="descriptions-item">
            <span class="key">所在河流:</span>
            <span class="value">{{ data.szhl || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">工程类型:</span>
            <span class="value">{{ data.gclx || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">联系人:</span>
            <span class="value">{{ data.lxr || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">联系电话:</span>
            <span class="value">{{ data.lxfs || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">行政区划代码:</span>
            <span class="value">{{ data.xzqhdm || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">行政区划名称:</span>
            <span class="value">{{ data.xzqhmc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">运行管理单位:</span>
            <span class="value">{{ data.yxgldw || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">工程地址:</span>
            <span class="value">{{ data.dd || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
const props = defineProps({
  data: Object,
})
const { data } = toRefs(props)
</script>

<style lang="scss" scoped>
.dialog-dam {
  width: 53.35rem;
  min-width: 53.35rem;
  .header {
    text-align: left;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 12.8rem;
            margin-right: 1.9rem;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>
